import {
  AppPublicLayout,
  AppPublicPage,
  PublicDocument,
} from "./../layout";

export function Avv() {
  return (
    <AppPublicLayout>
      <AppPublicPage width="narrow">
        <PublicDocument>
          <h1>Auftragsverarbeitungsvertrag (AVV) gemäß Art. 28 DSGVO</h1>

          <p className="lead">
            Version 1.0
          </p>

          <h2>Vertragsparteien</h2>

          <p>
            Dieser Auftragsverarbeitungsvertrag gilt ergänzend zu den
            Allgemeinen Geschäftsbedingungen von Logami.
          </p>

          <p>
            Vertragspartner sind der jeweilige Kunde von Logami als
            Verantwortlicher im Sinne der DSGVO sowie:
          </p>

          <address>
            Lukas Ottweiler
            <br />
            Logami
            <br />
            c/o MDC#986
            <br />
            Welserstraße 3
            <br />
            87463 Dietmannsried
            <br />
            Deutschland
            <br />
            E-Mail:{" "}
            <a href="mailto:kontakt@logami.de">kontakt@logami.de</a>
          </address>

          <p>(nachfolgend „Auftragsverarbeiter“)</p>

          <h2>1. Gegenstand des Vertrags</h2>

          <p>
            Der Auftragsverarbeiter stellt die Softwareplattform „Logami“ zur
            Verfügung.
          </p>

          <p>
            Im Rahmen der Nutzung verarbeitet der Auftragsverarbeiter
            personenbezogene Daten im Auftrag des Verantwortlichen.
          </p>

          <p>
            Dieser Vertrag konkretisiert die datenschutzrechtlichen Rechte und
            Pflichten der Parteien gemäß Art. 28 DSGVO.
          </p>

          <h2>2. Dauer der Verarbeitung</h2>

          <p>
            Die Verarbeitung erfolgt für die Dauer des zwischen den Parteien
            bestehenden Nutzungsvertrags über Logami.
          </p>

          <p>
            Mit Beendigung des Nutzungsvertrags endet auch dieser Vertrag,
            vorbehaltlich gesetzlicher Aufbewahrungspflichten.
          </p>

          <h2>3. Art und Zweck der Verarbeitung</h2>

          <p>
            Die Verarbeitung erfolgt zur Bereitstellung und Nutzung der Software
            Logami.
          </p>

          <p>Insbesondere können folgende Verarbeitungsvorgänge stattfinden:</p>

          <ul>
            <li>Speicherung und Bereitstellung von Kundendaten</li>
            <li>Verwaltung von Mitarbeitern</li>
            <li>Verwaltung von Aufträgen</li>
            <li>Erfassung und Speicherung von Arbeitszeiten</li>
            <li>Speicherung von Adressen</li>
            <li>Speicherung von Fotos</li>
            <li>Speicherung von Notizen</li>
            <li>Speicherung von Unterschriften</li>
            <li>Speicherung von GPS-Standorten</li>
            <li>Bereitstellung von Datenexporten</li>
            <li>Versand systembezogener E-Mails</li>
          </ul>

          <p>
            Die Verarbeitung erfolgt ausschließlich im Rahmen der Weisungen des
            Verantwortlichen.
          </p>

          <h2>4. Kategorien betroffener Personen</h2>

          <p>
            Die Verarbeitung kann insbesondere folgende Personengruppen
            betreffen:
          </p>

          <ul>
            <li>Mitarbeiter des Verantwortlichen</li>
            <li>Kunden des Verantwortlichen</li>
            <li>Ansprechpartner des Verantwortlichen</li>
            <li>Auftraggeber des Verantwortlichen</li>
            <li>sonstige durch den Verantwortlichen erfasste Personen</li>
          </ul>

          <h2>5. Kategorien personenbezogener Daten</h2>

          <p>
            Je nach Nutzung können insbesondere folgende Daten verarbeitet
            werden:
          </p>

          <h3>Stammdaten</h3>

          <ul>
            <li>Vorname</li>
            <li>Nachname</li>
            <li>Firmenname</li>
            <li>Kontaktdaten</li>
          </ul>

          <h3>Auftragsdaten</h3>

          <ul>
            <li>Einsatzorte</li>
            <li>Auftragsinformationen</li>
            <li>Notizen</li>
          </ul>

          <h3>Beschäftigtendaten</h3>

          <ul>
            <li>Arbeitszeiten</li>
            <li>Tätigkeitsnachweise</li>
            <li>Nutzerkonten</li>
          </ul>

          <h3>Standortdaten</h3>

          <ul>
            <li>GPS-Koordinaten</li>
            <li>Standortereignisse</li>
          </ul>

          <h3>Medien</h3>

          <ul>
            <li>Fotos</li>
            <li>Bilddokumentationen</li>
          </ul>

          <h3>Identifikationsdaten</h3>

          <ul>
            <li>Unterschriften</li>
            <li>Benutzerkennungen</li>
          </ul>

          <h3>Technische Daten</h3>

          <ul>
            <li>Login-Protokolle</li>
            <li>Geräteinformationen</li>
            <li>IP-Adressen</li>
            <li>Audit-Logs</li>
          </ul>

          <h2>6. Pflichten des Verantwortlichen</h2>

          <p>
            Der Verantwortliche ist für die Rechtmäßigkeit der Datenverarbeitung
            verantwortlich.
          </p>

          <p>Der Verantwortliche stellt insbesondere sicher, dass:</p>

          <ul>
            <li>personenbezogene Daten rechtmäßig erhoben werden,</li>
            <li>erforderliche Informationspflichten erfüllt werden,</li>
            <li>erforderliche Rechtsgrundlagen vorliegen,</li>
            <li>Beschäftigte über die Verarbeitung informiert werden,</li>
            <li>Weisungen datenschutzkonform sind.</li>
          </ul>

          <h2>7. Pflichten des Auftragsverarbeiters</h2>

          <p>Der Auftragsverarbeiter verpflichtet sich:</p>

          <ul>
            <li>
              personenbezogene Daten ausschließlich auf dokumentierte Weisung zu
              verarbeiten,
            </li>
            <li>Vertraulichkeit sicherzustellen,</li>
            <li>
              geeignete technische und organisatorische Maßnahmen umzusetzen,
            </li>
            <li>
              den Verantwortlichen bei datenschutzrechtlichen Anfragen
              angemessen zu unterstützen,
            </li>
            <li>Datenschutzverletzungen unverzüglich mitzuteilen,</li>
            <li>keine Daten unbefugt an Dritte weiterzugeben.</li>
          </ul>

          <h2>8. Vertraulichkeit</h2>

          <p>
            Der Auftragsverarbeiter stellt sicher, dass Personen mit Zugriff auf
            personenbezogene Daten zur Vertraulichkeit verpflichtet wurden oder
            einer gesetzlichen Verschwiegenheitspflicht unterliegen.
          </p>

          <p>
            Der Zugriff auf Daten erfolgt ausschließlich im erforderlichen
            Umfang.
          </p>

          <h2>9. Technische und organisatorische Maßnahmen (TOMs)</h2>

          <p>
            Der Auftragsverarbeiter setzt insbesondere folgende Maßnahmen um:
          </p>

          <h3>Zugangskontrolle</h3>

          <ul>
            <li>Passwortgeschützte Benutzerkonten</li>
            <li>Rollen- und Berechtigungskonzept</li>
            <li>Beschränkung administrativer Zugriffe</li>
          </ul>

          <h3>Zugriffskontrolle</h3>

          <ul>
            <li>Zugriff auf Produktionssysteme nur für berechtigte Personen</li>
            <li>Trennung von Administrator- und Nutzerrechten</li>
          </ul>

          <h3>Weitergabekontrolle</h3>

          <ul>
            <li>Verschlüsselte Datenübertragung mittels TLS</li>
            <li>Zugriff ausschließlich über authentifizierte Verbindungen</li>
          </ul>

          <h3>Verfügbarkeitskontrolle</h3>

          <ul>
            <li>Regelmäßige Datensicherungen</li>
            <li>Überwachung der Systeme</li>
            <li>Schutz vor Datenverlust</li>
          </ul>

          <h3>Integritätskontrolle</h3>

          <ul>
            <li>Audit- und Änderungsprotokolle</li>
            <li>Nachvollziehbarkeit relevanter Änderungen</li>
          </ul>

          <h3>Hosting</h3>

          <ul>
            <li>Hosting in Rechenzentren innerhalb Deutschlands</li>
          </ul>

          <h2>10. Unterauftragsverarbeiter</h2>

          <p>
            Der Verantwortliche stimmt dem Einsatz der folgenden
            Unterauftragsverarbeiter zu:
          </p>

          <table>
            <thead>
              <tr>
                <th>Dienst</th>
                <th>Zweck</th>
                <th>Standort</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Hetzner</td>
                <td>Hosting und Infrastruktur</td>
                <td>Deutschland</td>
              </tr>
              <tr>
                <td>Stripe</td>
                <td>Zahlungsabwicklung</td>
                <td>EU / USA</td>
              </tr>
              <tr>
                <td>Lettermint</td>
                <td>Versand transaktionaler E-Mails</td>
                <td>EU</td>
              </tr>
              <tr>
                <td>LocationIQ</td>
                <td>Geokodierung und Standortdienste</td>
                <td>EU / USA</td>
              </tr>
            </tbody>
          </table>

          <p>
            Der Auftragsverarbeiter informiert den Verantwortlichen über
            wesentliche Änderungen dieser Liste.
          </p>

          <h2>11. Drittlandübermittlungen</h2>

          <p>
            Soweit Dienste eingesetzt werden, die Daten außerhalb der
            Europäischen Union oder des Europäischen Wirtschaftsraums
            verarbeiten, erfolgt dies nur unter Einhaltung der Anforderungen der
            DSGVO.
          </p>

          <p>
            Hierzu können insbesondere Standardvertragsklauseln oder andere
            geeignete Garantien eingesetzt werden.
          </p>

          <h2>12. Unterstützung bei Betroffenenrechten</h2>

          <p>
            Der Auftragsverarbeiter unterstützt den Verantwortlichen nach
            Möglichkeit bei:
          </p>

          <ul>
            <li>Auskunftsersuchen</li>
            <li>Berichtigung</li>
            <li>Löschung</li>
            <li>Einschränkung der Verarbeitung</li>
            <li>Datenübertragbarkeit</li>
            <li>Widersprüchen</li>
          </ul>

          <p>
            Soweit eine Anfrage unmittelbar beim Auftragsverarbeiter eingeht,
            wird diese an den Verantwortlichen weitergeleitet.
          </p>

          <h2>13. Meldung von Datenschutzverletzungen</h2>

          <p>
            Der Auftragsverarbeiter informiert den Verantwortlichen unverzüglich
            über bekannt gewordene Verletzungen des Schutzes personenbezogener
            Daten.
          </p>

          <p>
            Die Mitteilung erfolgt mit den zum jeweiligen Zeitpunkt verfügbaren
            Informationen.
          </p>

          <h2>14. Nachweise und Audits</h2>

          <p>
            Der Auftragsverarbeiter stellt dem Verantwortlichen auf Anfrage
            Informationen zur Verfügung, die erforderlich sind, um die
            Einhaltung dieses Vertrags nachzuweisen.
          </p>

          <p>
            Audits sind nach vorheriger angemessener Ankündigung und unter
            Berücksichtigung berechtigter Geheimhaltungsinteressen zulässig.
          </p>

          <h2>15. Löschung und Rückgabe von Daten</h2>

          <p>
            Nach Beendigung des Nutzungsvertrags wird der Auftragsverarbeiter
            personenbezogene Daten löschen oder dem Verantwortlichen
            zurückgeben, soweit keine gesetzlichen Aufbewahrungspflichten
            entgegenstehen.
          </p>

          <p>
            Der Verantwortliche kann vorhandene Exportfunktionen nutzen, um
            Daten vor Vertragsende zu sichern.
          </p>

          <h2>16. Rangfolge</h2>

          <p>
            Bei Widersprüchen zwischen diesem Vertrag und dem Hauptvertrag gehen
            die Regelungen dieses Auftragsverarbeitungsvertrags hinsichtlich
            datenschutzrechtlicher Fragen vor.
          </p>

          <h2>17. Schlussbestimmungen</h2>

          <p>
            Im Übrigen gelten die Regelungen des zwischen den Parteien
            bestehenden Nutzungsvertrags.
          </p>

          <p>
            Sollten einzelne Bestimmungen dieses Vertrags unwirksam sein oder
            werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
          </p>
        </PublicDocument>
      </AppPublicPage>
    </AppPublicLayout>
  );
}

export default Avv;
